/* @flow */

export const APP_NAME = 'Renote';

export const LANG = 'en';

export const TIME_ZONE = 'en-EN';

export const GMAPS_API_KEY = 'AIzaSyBXNDm0zCJz86EuiFmdjmrGeTlgK9WJ3T4';

export const ANDROID_VERSIONS = {
  LOLLIPOP: 21
};

export const isCNDomain = () => {
  // return !window.location.hostname.includes('.net');
  return window.location.hostname.includes('.cn');
}

export const getMainDomain = () => {
  // Web 环境或开发环境，动态获取域名
  let fullDomain = window.location.hostname;

  if (fullDomain.includes('localhost')) {
    return fullDomain;
  }

  // 在 Electron 打包环境下，使用配置的域名
  if (isElectronApp() && process.env.APP_DOMAIN) {
    return process.env.APP_DOMAIN;
  }

  let domainParts = fullDomain.split('.'); // 拆分域名
  let mainDomain = domainParts[domainParts.length - 2] + '.' + domainParts[domainParts.length - 1];

  return mainDomain;
}

export const GOOGLE_ANALYTICS_TRACKID = 'G-RYTCZEQK0W';

export const MOBILE_MEDIA_QUERY = { query: '(max-width: 900px)' }

/**
 * Check if the application is running in Electron environment
 * @returns {boolean} true if running in Electron, false otherwise
 */
export const isElectronApp = () => {
  return typeof window !== 'undefined' &&
    (window.electronAPI !== undefined ||
      process.env.REACT_APP_IS_ELECTRON === 'true');
}

/**
 * Open a URL in external browser (for Electron) or new tab (for web)
 * @param {string} url - The URL to open
 */
export const openExternalLink = (url) => {
  if (isElectronApp() && window.electronAPI) {
    window.electronAPI.openExternal(url);
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}

/**
 * Navigate to a route in a way that's compatible with both web and Electron
 * Uses window.location.hash for Electron compatibility with HashRouter
 * @param {object} history - React Router history object
 * @param {string|object} location - Path string or location object with pathname and search
 */
export const navigateTo = (history, location) => {
  if (isElectronApp()) {
    // In Electron, use window.location.hash for more reliable navigation
    if (typeof location === 'string') {
      window.location.hash = '#' + location;
    } else if (location.pathname) {
      const search = location.search ? (location.search.startsWith('?') ? location.search : '?' + location.search) : '';
      window.location.hash = '#' + location.pathname + search;
    }

  } else {
    // In web, use history.push as normal
    history.push(location);
  }
}